(function ($, Drupal, drupalSettings) {

  'use strict';

  Drupal.behaviors.form = {
    attach: function (context, settings) {

      $('.form-item .form-control').each(function( index, element ) {
        if($(this).val().length > 0) {
          $(this).parents('.form-item').addClass('focus');
        }
      });
      $('.form-item .form-control').bind('focus keyup', function () {
        $(this).parents('.form-item').addClass('focus');
      });
      $('.form-item .form-control').focusout(function() {
        if($(this).val().length === 0) {
          $(this).parents('.form-item').removeClass('focus');
        }
      });

    }
  };
})(jQuery, Drupal, drupalSettings);
